module.exports = __webpack_public_path__ + "img/menu_black.14797d0c.svg";